import initialState from '../../../store/initialState';
import * as types from '../services/CapacityTableActionType';

const capacityTableReducer = (state = initialState.capacityTableReducer, action) => {
    switch (action.type) {
        case types.FETCH_CAPACITY_TABLE_REPORTS_REQUEST:
            return {
                ...state,
                isCapacityTableLoading: true,
                error: null,
            };
        case types.FETCH_CAPACITY_TABLE_REPORTS_SUCCESS:
            return {
                ...state,
                isCapacityTableLoading: false,
                capacityTableReports: action.payload?.values?.capacityTableList || [],
                recordsTotal: action.payload?.recordsTotal || 0,
                recordsFiltered: action.payload?.recordsFiltered || 0,
                error: null,
            };
        case types.FETCH_CAPACITY_TABLE_REPORTS_FAILURE:
            return {
                ...state,
                isCapacityTableLoading: false,
                capacityTableReports: [],
                error: action.error,
            };

        case types.UPDATE_CAPACITY_TABLE_REDUCER:
            return {
                ...state,
                ...action.payload,
            };

        case types.FETCH_CAPACITY_NOTES_EDIT_REQUEST:
            return {
                ...state,
                isCapacityTableLoading: true,
                error: null,
            };
        case types.FETCH_CAPACITY_NOTES_EDIT_SUCCESS:
            return {
                ...state,
                isCapacityTableLoading: false,
                notesEditData: action.payload,
                error: null,
            };
        case types.FETCH_CAPACITY_NOTES_EDIT_FAILURE:
            return {
                ...state,
                isCapacityTableLoading: false,
                error: action.error,
            };

        case types.FETCH_CAPACITY_NOTES_SAVE_REQUEST:
            return {
                ...state,
                isCapacityTableLoading: true,
                error: null,
            };
        case types.FETCH_CAPACITY_NOTES_SAVE_SUCCESS:
            return {
                ...state,
                isCapacityTableLoading: false,
                notesSaveSuccess: true,
                error: null,
            };
        case types.FETCH_CAPACITY_NOTES_SAVE_FAILURE:
            return {
                ...state,
                isCapacityTableLoading: false,
                notesSaveSuccess: false,
                error: action.error,
            };

        case types.DELETE_CAPACITY_REPORT_REQUEST:
            return {
                ...state,
                isCapacityTableLoading: true,
                error: null,
            };
        case types.DELETE_CAPACITY_REPORT_SUCCESS:
            return {
                ...state,
                isCapacityTableLoading: false,
                deleteSuccess: true,
                error: null,
            };
        case types.DELETE_CAPACITY_REPORT_FAILURE:
            return {
                ...state,
                isCapacityTableLoading: false,
                deleteSuccess: false,
                error: action.error,
            };

        case types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_REQUEST:
            return {
                ...state,
                isPublishedReportsListLoading: true,
                error: null,
            };
        case types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_SUCCESS:
            return {
                ...state,
                isPublishedReportsListLoading: false,
                publishedReportsList: action.payload?.values?.reportsDDList || [],
                error: null,
            };
        case types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_FAILURE:
            return {
                ...state,
                isPublishedReportsListLoading: false,
                publishedReportsList: [],
                error: action.error,
            };

        case types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_REQUEST:
            return {
                ...state,
                isCapacityTableLoading: true,
                error: null,
            };
        case types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_SUCCESS:
            return {
                ...state,
                isCapacityTableLoading: false,
                error: null,
            };
        case types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_FAILURE:
            return {
                ...state,
                isCapacityTableLoading: false,
                error: action.error,
            };

        case types.COVERAGE_GAP_TOOL_DATA_REFRESH_REQUEST:
            return {
                ...state,
                // No loading state for this as it runs in background
                error: null,
            };
        case types.COVERAGE_GAP_TOOL_DATA_REFRESH_SUCCESS:
            return {
                ...state,
                error: null,
            };
        case types.COVERAGE_GAP_TOOL_DATA_REFRESH_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        case types.GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_REQUEST:
            return {
                ...state,
                isDropdownListsLoading: true,
                error: null,
            };
        case types.GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_SUCCESS:
            return {
                ...state,
                isDropdownListsLoading: false,
                shiftStartDateDDList: action.payload?.values?.shiftStartDateDDList || [],
                radiologistDDList: action.payload?.values?.radiologistDDlist || [],
                worklistDDList: action.payload?.values?.worklistDDList || [],
                taskDDList: action.payload?.values?.taskDDList || [],
                rpceDDList: action.payload?.values?.rpceDDList || [],
                dayDDList: action.payload?.values?.dayDDList || [],
                recurDayDDList: action.payload?.values?.recurDayDDList || [],
                weekRotationDDList: action.payload?.values?.weekRotationDDList || [],
                emulatorLegendDDList: action.payload?.values?.emulatorLegendDDList || [],
                error: null,
            };
        case types.GET_RAD_SHIFT_PASTE_INPUT_ALL_DD_LIST_FAILURE:
            return {
                ...state,
                isDropdownListsLoading: false,
                shiftStartDateDDList: [],
                radiologistDDList: [],
                worklistDDList: [],
                taskDDList: [],
                rpceDDList: [],
                dayDDList: [],
                recurDayDDList: [],
                weekRotationDDList: [],
                emulatorLegendDDList: [],
                error: action.error,
            };

        case types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_REQUEST:
            return {
                ...state,
                isShiftPasteInputLoading: true,
                error: null,
            };
        case types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_SUCCESS:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: action.payload?.values?.ListShiftpasteInput || [],
                shiftPasteInputRecordsTotal: action.payload?.values?.recordsTotal || 0,
                error: null,
            };
        case types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_FAILURE:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: [],
                shiftPasteInputRecordsTotal: 0,
                error: action.error,
            };

        // Get Shift Paste Input Refresh Data With Pagination Reducer Cases
        case types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_REQUEST:
            return {
                ...state,
                isShiftPasteInputLoading: true,
                error: null,
            };
        case types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_SUCCESS:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: action.payload?.values?.ListShiftpasteInput || [],
                shiftPasteInputRecordsTotal: action.payload?.values?.recordsTotal || 0,
                error: null,
            };
        case types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_FAILURE:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: [],
                shiftPasteInputRecordsTotal: 0,
                error: action.error,
            };

        // Publish Capacity Table Report Reducer Cases
        case types.PUBLISH_CAPACITY_TABLE_REPORT_REQUEST:
            return {
                ...state,
                isPublishCapacityTableReportLoading: true,
                error: null,
            };
        case types.PUBLISH_CAPACITY_TABLE_REPORT_SUCCESS:
            return {
                ...state,
                isPublishCapacityTableReportLoading: false,
                publishCapacityTableReportSuccess: true,
                error: null,
            };
        case types.PUBLISH_CAPACITY_TABLE_REPORT_FAILURE:
            return {
                ...state,
                isPublishCapacityTableReportLoading: false,
                publishCapacityTableReportSuccess: false,
                error: action.error,
            };

        case types.GET_CAPACITY_TABLE_REPORT_REQUEST:
            return {
                ...state,
                isCapacityTableReportLoading: true,
                error: null,
            };
        case types.GET_CAPACITY_TABLE_REPORT_SUCCESS:
            return {
                ...state,
                isCapacityTableReportLoading: false,
                capacityTableReportData: action.payload?.values || null,
                error: null,
            };
        case types.GET_CAPACITY_TABLE_REPORT_FAILURE:
            return {
                ...state,
                isCapacityTableReportLoading: false,
                capacityTableReportData: null,
                error: action.error,
            };

        case types.GET_ACTIVE_RAD_DATA_BY_ID_REQUEST:
            return {
                ...state,
                isActiveRadDataLoading: true,
                error: null,
            };
        case types.GET_ACTIVE_RAD_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                isActiveRadDataLoading: false,
                activeRadData: action.payload?.values?.listCapacityActiveRadData || [],
                error: null,
            };
        case types.GET_ACTIVE_RAD_DATA_BY_ID_FAILURE:
            return {
                ...state,
                isActiveRadDataLoading: false,
                activeRadData: [],
                error: action.error,
            };

        case types.GET_PENDING_RAD_DATA_BY_ID_REQUEST:
            return {
                ...state,
                isPendingRadDataLoading: true,
                error: null,
            };
        case types.GET_PENDING_RAD_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                isPendingRadDataLoading: false,
                pendingRadData: action.payload?.values?.listCapacityPendingRadData || [],
                error: null,
            };
        case types.GET_PENDING_RAD_DATA_BY_ID_FAILURE:
            return {
                ...state,
                isPendingRadDataLoading: false,
                pendingRadData: [],
                error: action.error,
            };

        case types.GET_OFFBOARDING_RAD_DATA_BY_ID_REQUEST:
            return {
                ...state,
                isOffboardingRadDataLoading: true,
                error: null,
            };
        case types.GET_OFFBOARDING_RAD_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                isOffboardingRadDataLoading: false,
                offboardingRadData: action.payload?.values?.listCapacityOffboardingRadData || [],
                error: null,
            };
        case types.GET_OFFBOARDING_RAD_DATA_BY_ID_FAILURE:
            return {
                ...state,
                isOffboardingRadDataLoading: false,
                offboardingRadData: [],
                error: action.error,
            };

        case types.SAVE_IS_EXCLUDED_REQUEST:
            return {
                ...state,
                isSaveIsExcludedLoading: true,
                error: null,
            };
        case types.SAVE_IS_EXCLUDED_SUCCESS:
            return {
                ...state,
                isSaveIsExcludedLoading: false,
                saveIsExcludedResponse: action.payload,
            };
        case types.SAVE_IS_EXCLUDED_FAILURE:
            return {
                ...state,
                isSaveIsExcludedLoading: false,
                error: action.error,
            };

        case types.GET_DUPLICATE_SCHEDULE_DATA_REQUEST:
            return {
                ...state,
                isShiftPasteInputLoading: true,
                error: null,
            };
        case types.GET_DUPLICATE_SCHEDULE_DATA_SUCCESS:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: action.payload?.values?.ListShiftpasteInput || [],
                shiftPasteInputRecordsTotal: action.payload?.values?.recordsTotal || 0,
                error: null,
            };
        case types.GET_DUPLICATE_SCHEDULE_DATA_FAILURE:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                shiftPasteInputList: [],
                shiftPasteInputRecordsTotal: 0,
                error: action.error,
            };

        // Delete Duplicate Shift Paste Input Data cases
        case types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_REQUEST:
            return {
                ...state,
                isDeleteDuplicateLoading: true,
                deleteDuplicateResponse: null,
                error: null
            };
        case types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_SUCCESS:
            return {
                ...state,
                isDeleteDuplicateLoading: false,
                deleteDuplicateResponse: action.payload,
                error: null
            };
        case types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_FAILURE:
            return {
                ...state,
                isDeleteDuplicateLoading: false,
                deleteDuplicateResponse: null,
                error: action.error
            };

        // Delete Shift Input Details Cases
        case types.DELETE_SHIFT_INPUT_DETAILS_REQUEST:
            return {
                ...state,
                isDeleteShiftInputDetailsLoading: true,
                error: null,
            };
        case types.DELETE_SHIFT_INPUT_DETAILS_SUCCESS:
            return {
                ...state,
                isDeleteShiftInputDetailsLoading: false,
                deleteShiftInputDetailsResponse: action.payload,
                error: null,
            };
        case types.DELETE_SHIFT_INPUT_DETAILS_FAILURE:
            return {
                ...state,
                isDeleteShiftInputDetailsLoading: false,
                deleteShiftInputDetailsResponse: null,
                error: action.error,
            };

        // Get Shift Input Details By ID Cases
        case types.GET_SHIFT_INPUT_DETAILS_BY_ID_REQUEST:
            return {
                ...state,
                isGetShiftInputDetailsLoading: true,
                error: null,
            };
        case types.GET_SHIFT_INPUT_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                isGetShiftInputDetailsLoading: false,
                shiftInputDetailsData: action.payload,
                error: null,
            };
        case types.GET_SHIFT_INPUT_DETAILS_BY_ID_FAILURE:
            return {
                ...state,
                isGetShiftInputDetailsLoading: false,
                shiftInputDetailsData: null,
                error: action.error,
            };
            
        // Update Radiologist Shift Input Details Cases
        case types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST:
            return {
                ...state,
                isUpdateShiftInputDetailsLoading: true,
                updateShiftInputDetailsError: null
            };
        case types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS:
            return {
                ...state,
                isUpdateShiftInputDetailsLoading: false,
                updateShiftInputDetailsData: action.payload,
                updateShiftInputDetailsError: null
            };
        case types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE:
            return {
                ...state,
                isUpdateShiftInputDetailsLoading: false,
                updateShiftInputDetailsError: action.error
            };

        // Get Simulator RPCE With Pagination Cases
        case types.GET_SIMULATOR_RPCE_WITH_PAGINATION_REQUEST:
            return {
                ...state,
                isSimulatorRPCELoading: true,
                simulatorRPCEData: [],
                simulatorRPCERecordsTotal: 0,
                simulatorRPCERecordsFiltered: 0,
                error: null
            };
        case types.GET_SIMULATOR_RPCE_WITH_PAGINATION_SUCCESS:
            return {
                ...state,
                isSimulatorRPCELoading: false,
                simulatorRPCEData: action.payload?.values || [],
                simulatorRPCERecordsTotal: action.payload?.recordsTotal || 0,
                simulatorRPCERecordsFiltered: action.payload?.recordsFiltered || 0,
                error: null
            };
        case types.GET_SIMULATOR_RPCE_WITH_PAGINATION_FAILURE:
            return {
                ...state,
                isSimulatorRPCELoading: false,
                simulatorRPCEData: [],
                error: action.error
            };

        // Get Capacity Table Grid Data With Pagination Cases
        case types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_REQUEST:
            return {
                ...state,
                isCapacityTableGridLoading: true,
                error: null
            };
        case types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_SUCCESS:
            return {
                ...state,
                isCapacityTableGridLoading: false,
                capacityTableGridData: action.payload?.values?.lstCapacityTable?.length > 0 
                    ? action.payload.values.lstCapacityTable 
                    : action.payload?.values?.lstCapacityRPCETable || [],
                capacityTableGridRecordsTotal: action.payload?.recordsTotal || 0,
                capacityTableGridRecordsFiltered: action.payload?.recordsFiltered || 0,
                error: null
            };
        case types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_FAILURE:
            return {
                ...state,
                isCapacityTableGridLoading: false,
                capacityTableGridData: [],
                capacityTableGridRecordsTotal: 0,
                capacityTableGridRecordsFiltered: 0,
                error: action.error
            };

        // Draft Capacity Table Report cases
        case types.DRAFT_CAPACITY_TABLE_REPORT_REQUEST:
            return {
                ...state,
                isDraftCapacityTableReportLoading: true,
                error: null
            };
        case types.DRAFT_CAPACITY_TABLE_REPORT_SUCCESS:
            return {
                ...state,
                isDraftCapacityTableReportLoading: false,
                draftCapacityTableReportSuccess: true,
                error: null
            };
        case types.DRAFT_CAPACITY_TABLE_REPORT_FAILURE:
            return {
                ...state,
                isDraftCapacityTableReportLoading: false,
                draftCapacityTableReportSuccess: false,
                error: action.error
            };

        // Shift Paste Input Duplicate Check cases
        case types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_REQUEST:
            return {
                ...state,
                isShiftPasteInputDuplicateCheckLoading: true,
                error: null
            };
        case types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_SUCCESS:
            return {
                ...state,
                isShiftPasteInputDuplicateCheckLoading: false,
                shiftPasteInputDuplicateCheckResponse: action.payload,
                error: null
            };
        case types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_FAILURE:
            return {
                ...state,
                isShiftPasteInputDuplicateCheckLoading: false,
                shiftPasteInputDuplicateCheckResponse: null,
                error: action.error
            };

        case types.GET_CAPACITY_TABLE_REFRESH_DATA_REQUEST:
            return {
                ...state,
                isCapacityTableRefreshLoading: true,
                error: null
            };
        case types.GET_CAPACITY_TABLE_REFRESH_DATA_SUCCESS:
            return {
                ...state,
                isCapacityTableRefreshLoading: false,
                capacityTableGridData: action.payload?.values?.lstCapacityTable || [],
                error: null
            };
        case types.GET_CAPACITY_TABLE_REFRESH_DATA_FAILURE:
            return {
                ...state,
                isCapacityTableRefreshLoading: false,
                error: action.error
            };

        case types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_REQUEST:
            return { ...state, isSimulatorRPCELoading: true }
        case types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_SUCCESS:
            return {
                ...state,
                isSimulatorRPCELoading: false,
                simulatorWorklistData: action.payload?.values || [],
                simulatorWorklistRecordsTotal: action.payload?.recordsTotal || 0,
                simulatorWorklistRecordsFiltered: action.payload?.recordsFiltered || 0,
            }
        case types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_FAILURE:
            return { ...state, isSimulatorRPCELoading: false }

        case types.GET_CAPACITY_RPCE_DETAILS_REQUEST:
            return { 
                ...state, 
                isCapacityRPCEDetailsLoading: true,
                capacityRPCEDetailsData: null
            }
        case types.GET_CAPACITY_RPCE_DETAILS_SUCCESS:
            return {
                ...state,
                isCapacityRPCEDetailsLoading: false,
                capacityRPCEDetailsData: action.payload,
            }
        case types.GET_CAPACITY_RPCE_DETAILS_FAILURE:
            return { 
                ...state, 
                isCapacityRPCEDetailsLoading: false,
                capacityRPCEDetailsData: null
            }

        // Get Capacity Details Cases (for worklist)
        case types.GET_CAPACITY_DETAILS_REQUEST:
            return { 
                ...state, 
                isCapacityDetailsLoading: true,
                capacityDetailsData: null
            }
        case types.GET_CAPACITY_DETAILS_SUCCESS:
            return {
                ...state,
                isCapacityDetailsLoading: false,
                capacityDetailsData: action.payload,
            }
        case types.GET_CAPACITY_DETAILS_FAILURE:
            return { 
                ...state, 
                isCapacityDetailsLoading: false,
                capacityDetailsData: null
            }

        // Save Radiologist Shift Input Details
        case types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST:
            return {
                ...state,
                isSaveRadiologistShiftInputDetailsLoading: true,
                saveRadiologistShiftInputDetailsError: null,
            };
        case types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS:
            return {
                ...state,
                isSaveRadiologistShiftInputDetailsLoading: false,
                saveRadiologistShiftInputDetailsError: null,
                saveRadiologistShiftInputDetailsSuccess: action.payload,
            };
        case types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE:
            return {
                ...state,
                isSaveRadiologistShiftInputDetailsLoading: false,
                saveRadiologistShiftInputDetailsError: action.error,
            };

        // Get All Emulator Data Cases (for simulator refresh - worklist)
        case types.GET_ALL_EMULATOR_DATA_REQUEST:
            return { 
                ...state, 
                isSimulatorRefreshLoading: true,
                simulatorRefreshError: null
            }
        case types.GET_ALL_EMULATOR_DATA_SUCCESS:
            return {
                ...state,
                isSimulatorRefreshLoading: false,
                simulatorRefreshError: null,
                emulatorWorklistData: action.payload,
            }
        case types.GET_ALL_EMULATOR_DATA_FAILURE:
            return { 
                ...state, 
                isSimulatorRefreshLoading: false,
                simulatorRefreshError: action.error
            }

        // Get All Emulator RPCE Data Cases (for simulator refresh - RPCE)
        case types.GET_ALL_EMULATOR_RPCE_DATA_REQUEST:
            return { 
                ...state, 
                isSimulatorRPCERefreshLoading: true,
                simulatorRPCERefreshError: null
            }
        case types.GET_ALL_EMULATOR_RPCE_DATA_SUCCESS:
            return {
                ...state,
                isSimulatorRefreshLoading: false,
                isSimulatorRPCERefreshLoading: false,
                simulatorRPCERefreshError: null,
                emulatorRPCEData: action.payload,
            }
        case types.GET_ALL_EMULATOR_RPCE_DATA_FAILURE:
            return { 
                ...state, 
                isSimulatorRefreshLoading: false,
                isSimulatorRPCERefreshLoading: false,
                simulatorRPCERefreshError: action.error
            }

        // Get QGenda Tasks And Schedules Cases
        case types.GET_QGENDA_TASKS_SCHEDULES_REQUEST:
            return {
                ...state,
                // show the same loader used for shift paste input pagination
                isShiftPasteInputLoading: true,
                error: null
            };
        case types.GET_QGENDA_TASKS_SCHEDULES_SUCCESS:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                qgendaTasksSchedulesResponse: action.payload || null,
                error: null
            };
        case types.GET_QGENDA_TASKS_SCHEDULES_FAILURE:
            return {
                ...state,
                isShiftPasteInputLoading: false,
                qgendaTasksSchedulesResponse: null,
                error: action.error
            };

        default:
            return state;
    }
};

export default capacityTableReducer;